import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { createStructuredSelector } from "reselect";
import { makeSelectorGetLiteTradeAssetInfo } from "../../../modules/LiteTrade/liteTradeSelectors.js";
import { connect } from "react-redux";
import { Loader } from "../../../components/Loader/Loader.jsx";
import {
    MobileAssetInfoContentStyled,
    MobileAssetInfoMenuStyled
} from "../MobileSliderPages/components/styled/MobileAssetInfoHeaderStyled.js";
import MobileAssetInfoOverview from "./MobileAssetInfoOverview.jsx";
import { MobileAssetInfoWrapperStyled } from "./styled/MobileAssetInfoStyled";
import { formatAssetInfoTradingHours } from "./mobileAssetInfoUtils";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";

const mobileAssetInfoMenu = [{
    tab: 'overview',
    title: 'lite_version.home.overview',
}, {
    tab: 'details',
    title: 'lite_version.order.details',
}, {
    tab: 'schedule',
    title: 'lite_version.order.schedule',
}];

function MobileAssetInfo(props) {
    const {
        assetInfo,
    } = props;

    const {getLangPath} = useLangContext();
    const [selectedTab, setSelectedTab] = useState(null);
    const location = useLocation();
    const {locale} = useLangContext();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        if (!selectedTab) {
            setSelectedTab(tabParam || 'overview');
        }
    }, [location, selectedTab]);

    const handleTabClick = useCallback((e) => {
        e.preventDefault();
        setSelectedTab(e.currentTarget.dataset.tab);
    }, []);

    const parsedTradingHours = useMemo(() =>
        formatAssetInfoTradingHours(assetInfo?.info?.tradingHours, locale), [assetInfo, locale]);

    if (!assetInfo) {
        return <Loader show={true}/>
    }

    return <>
        <MobileAssetInfoMenuStyled>
            {mobileAssetInfoMenu.map(item => <Fragment key={item.tab}>
                <div data-tab={item.tab}
                     onClick={handleTabClick}
                     className={`${item.tab === selectedTab ? 'selected' : ''}`}>
                    {getLangPath(item.title)}
                </div>
            </Fragment>)}
        </MobileAssetInfoMenuStyled>

        <MobileAssetInfoContentStyled>
            {
                {
                    overview: <MobileAssetInfoOverview symbol={assetInfo.symbol}/>,
                    details: <>
                        <MobileAssetInfoWrapperStyled>
                            <table>
                                <tbody>
                                <tr>
                                    <th>{getLangPath('lite_version.asset_screen.asset_type')}</th>
                                    <td>{assetInfo.type}</td>
                                </tr>
                                <tr>
                                    <th>{getLangPath('lite_version.asset_screen.lot_size')}</th>
                                    <td>{assetInfo.info.lotSize}</td>
                                </tr>
                                <tr>
                                    <th>{getLangPath('lite_version.asset_screen.trade_size')}</th>
                                    <td>{getLangPath('lite_version.order.lots_count', {
                                        number: `${assetInfo.minOrderSize}-${assetInfo.maxOrderSize?.value}`})}
                                    </td>
                                </tr>
                                <tr>
                                    <th>{getLangPath('lite_version.asset_screen.lot_step')}</th>
                                    <td>{assetInfo.minOrderSizeIncrement}</td>
                                </tr>
                                </tbody>
                            </table>
                        </MobileAssetInfoWrapperStyled>
                        <MobileAssetInfoWrapperStyled className="mt-3">
                            <p className={'f16 fw600'}>{getLangPath('lite_version.asset_screen.margin_rate')}</p>
                            <table>
                                <tbody>
                                {
                                    assetInfo.marginRate.tiers.map(item => <tr key={item.endVolume}>
                                        <th>{item.endVolume}</th>
                                        <td>{item.value}</td>
                                    </tr>)
                                }
                                </tbody>
                            </table>
                        </MobileAssetInfoWrapperStyled>
                    </>,
                    schedule: <MobileAssetInfoWrapperStyled>
                        <p className={'f16 fw600'}>{getLangPath('lite_version.asset_screen.trading_hours')}</p>
                        <table>
                            <tbody>
                            {
                                parsedTradingHours.map(item => <tr key={item.weekDay}>
                                    <th style={{flexBasis: '30%'}}>{item.weekDay}</th>
                                    <td>{item.intervals.map(item => `${item.startTime}-${item.endTime}`).join(', ')}</td>
                                </tr>)
                            }
                            </tbody>
                        </table>
                    </MobileAssetInfoWrapperStyled>,
                }[selectedTab]
            }
        </MobileAssetInfoContentStyled>
    </>
}

const mapStateToProps = createStructuredSelector({
    assetInfo: (state, ownProps) => makeSelectorGetLiteTradeAssetInfo(ownProps.symbol)(state, ownProps)
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAssetInfo);
